import { render } from "./AdminProjectTypes.vue?vue&type=template&id=5dd67bb0"
import script from "./AdminProjectTypes.vue?vue&type=script&lang=js"
export * from "./AdminProjectTypes.vue?vue&type=script&lang=js"

import "./AdminProjectTypes.vue?vue&type=style&index=0&id=5dd67bb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__